import React from 'react'
import FormSender from '../components/orderPage/formSender/FormSender'

const OrderPage = ({data}) => {
  return (
      <div><FormSender data={data.formControll}/></div>
  )
}

export default OrderPage